import cx from 'classnames';

import { CustomButtonBase } from 'src/components/CustomButtonBase';
import {
  GENERATION_TOOL_CARD_IMAGE_SIZE,
  GenerationToolCardImage,
} from 'src/components/GenerationToolCardImage';
// @ts-expect-error - TruncatedTypography is not typed yet
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';
import { type GenerationTool } from 'src/data/generationTool';
import type { ProjectType } from 'src/data/project';
import type { MultiPromptTemplate } from 'src/data/template';
import type { VoidFunction } from 'src/lib/types';

import styles from './CardSmall.module.scss';

interface CardSmallProps {
  className?: string;
  projectType: ProjectType;
  generationTool: GenerationTool;
  customToolData?: MultiPromptTemplate;
  title: string;
  selected?: boolean;
  onClick: VoidFunction;
  disabled?: boolean;
}

/**
 * A template as a single row: the card's own image and its name, and none of the description the
 * bigger cards carry. For lists read at a glance rather than browsed — the rail's hover previews.
 */
export const CardSmall = ({
  className,
  projectType,
  generationTool,
  customToolData,
  title,
  selected,
  onClick,
  disabled,
}: CardSmallProps) => (
  <CustomButtonBase
    className={cx(styles.root, className, {
      [styles.selected]: selected,
      [styles.disabled]: disabled,
    })}
    onClick={disabled ? undefined : onClick}
  >
    <GenerationToolCardImage
      className={styles.icon}
      projectType={projectType}
      tool={generationTool}
      svgStringImage={customToolData?.smallImage}
      size={GENERATION_TOOL_CARD_IMAGE_SIZE.small}
    />

    <TruncatedTypography
      className={styles.title}
      variant={TYPOGRAPHY_VARIANT.regular14}
    >
      {title}
    </TruncatedTypography>
  </CustomButtonBase>
);
